import script from "./ShowSmsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowSmsModal.vue?vue&type=script&setup=true&lang=js"

import "./ShowSmsModal.vue?vue&type=style&index=0&id=2d40ad62&lang=css"

const __exports__ = script;

export default __exports__